import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./CategoryDetailsBooth.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Link, useLocation, useParams} from 'react-router-dom';
import {useState, useEffect} from 'react';
import Image from 'react-bootstrap/Image';
import Category from "../category";
import Pricing from "./Pricing";
import { log } from "console";
import Addons from "./Addons";

type CategoryItem = {
  text: string;
  img_src: string;
  description: string;
}

type Catergory = {
  title: string;
  id: string;
  products: CategoryItem[];
}


const handleClick = () => {
    const element = document.getElementById("contact");
    if (element) {
      element.scrollIntoView();
    // ref.current?.scrollIntoView({behavior: 'smooth'});
    }
      };

function FlowerWall() {
  const [data,setData]=useState<Catergory[] | undefined>(undefined);

  const location = useLocation();
  //const propsData = location.state as any;
  

  useEffect(()=>{
    const element = document.getElementById("service");
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
  },[])


  return (

<div>
      <section className="features">
         <Container>

        <div className="section-title">
          <h1>Flower Walls for Rent in Edmonton</h1>
          <h2>Flower walls add elegance to your wedding or corporate event </h2>
          <p>Explore our collection of premium flower walls, perfect for weddings, parties, photo backdrops, corporate events, and more. From classic roses to lush peonies and bold tropical blooms, our flower walls add elegance, color, and Instagram-worthy style to any occasion. Whether you're looking for timeless romance or a modern floral statement, find the perfect backdrop here to elevate your event.</p>
        </div>
 

        <Row className="justify-content-center align-items-center">

<Col md={3} className="pt-4 picture-box">
<div className="service-box">
              <figure>
                <Link to="/category/flowerwall/pink">
                  <img
                    src="/images/pinkwall.jpg"
                    className="zoom img-fluid "
                    alt=""
                  />
                </Link>
                <span className="hoverle">
                Pink Flower Wall
            
                </span>
              </figure>
            </div>

</Col>
<Col md={3} className="pt-4 picture-box">
<div className="service-box">
              <figure>
                <Link to="/category/flowerwall/green">
                  <img
                    src="/images/greenwall.jpg"
                    className="zoom img-fluid "
                    alt=""
                  />
                </Link>
                <span className="hoverle">
                Green Flower Wall
            
                </span>
              </figure>
            </div>

</Col>
<Col md={3} className="pt-4 picture-box">
<div className="service-box">
              <figure>
                <Link to="/category/flowerwall/white">
                  <img
                    src="/images/whitewall.jpg"
                    className="zoom img-fluid "
                    alt=""
                  />
                </Link>
                <span className="hoverle">
                <p>White Flower Wall</p>
            
                </span>
              </figure>
            </div>

</Col>

</Row>














        </Container>
    


    
       
      </section>
      <section className="pricing section-bg" data-aos="fade-up">
            <div className="container">
    
            <div className="section-title">
                <h2>Pricing</h2>
                {/* <p>Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex aliquid fuga eum quidem. Sit sint consectetur velit. Quisquam quos quisquam cupiditate. Et nemo qui impedit suscipit alias ea. Quia fugiat sit in iste officiis commodi quidem hic quas.</p> */}
            </div>
<Row className="no-gutters justify-content-center align-items-center">



<Col lg={4} className="box featured">
<h3>Event Rental</h3>
    <h4>$150 for up to 24 hours</h4>
    <ul>
    <li><i className="bx bx-check"></i> Professional Stand</li>
        <li><i className="bx bx-check"></i> Setup & Takedown</li>
    </ul>
    <a onClick={handleClick} className="get-started-btn">Get Started</a>
</Col>




</Row>
</div>
</section>

</div>
  );
}



export default FlowerWall;


